import React from 'react'
import './Footer.css'

const Footer = () => {
  return (
    <footer className='footer'>
        Copyright &#169; 2023 Karthick Alagar. All right received.
    </footer>
  )
}

export default Footer